import type { OrderTakingWindow } from '@repo/utils';

import type * as orderHistoryText from '../data/order-history.json';
import type * as otText from '../data/ot-frontend.json';

type Translation = typeof orderHistoryText & typeof otText;

type Primitive = null | undefined | string | number | boolean | symbol | bigint;
type LiteralUnion<LiteralType, BaseType extends Primitive> = LiteralType | (BaseType & { _?: never });

interface SaljaWindow extends OrderTakingWindow {
    salja: {
        orders?: {
            text?: Translation;
        };
        orderHistory?: {
            translation?: Translation;
        };
    };
}
declare const window: SaljaWindow;

export const getOtTranslations = () => window.salja.orders?.text;
export const getOhTranslations = () => window.salja.orderHistory?.translation;
export type TranslationKeysType = keyof Translation;

export type KeyType = LiteralUnion<TranslationKeysType, string>;
export type DynamicKey = Record<string, string>;
